import { render, staticRenderFns } from "./TheUserMenu.vue?vue&type=template&id=1cfc0c04&scoped=true"
import script from "./TheUserMenu.vue?vue&type=script&lang=js"
export * from "./TheUserMenu.vue?vue&type=script&lang=js"
import style0 from "./TheUserMenu.vue?vue&type=style&index=0&id=1cfc0c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc0c04",
  null
  
)

export default component.exports